import { useLayoutEffect } from 'react';

let dismissed = false;

/** Fades out the fixed `#rl-boot-skeleton` overlay from `public/index.html`. */
export const dismissBootSkeleton = (): void => {
  if (dismissed) {
    return;
  }
  dismissed = true;
  const remove = (window as unknown as Record<string, (() => void) | undefined>)
    .__removeBootSkeleton;

  remove?.();
};

export const useDismissBootSkeleton = (enabled = true): void => {
  useLayoutEffect(() => {
    if (enabled) {
      dismissBootSkeleton();
    }
  }, [enabled]);
};
